module.exports = __webpack_public_path__ + "img/7.8c43ba68.svg";